import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AssessmentStatusDropdownComponent } from '@leads/shared/components/assessment-status-dropdown/assessment-status-dropdown.component';
import { CalendarCustomActionType, ICalendarEventOffcanvas } from '@schedule/lib/models/calendar-event-offcanvas';
import { AlertComponent } from '@shared/components/alerts/alert/alert.component';
import { LinkLocationComponent } from '@shared/components/buttons/link-location/link-location.component';
import { AlertTypes } from '@shared/models/alert';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';

@Component({
	selector: 'app-calendar-offcanvas',
	imports: [CommonModule, FormsModule, LinkLocationComponent, AssessmentStatusDropdownComponent, AlertComponent],
	templateUrl: './calendar-offcanvas.component.html',
	styleUrl: './calendar-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class CalendarOffcanvasComponent {
	@Input() calendarEventOffcanvas: ICalendarEventOffcanvas;

	CalendarCustomActionType = CalendarCustomActionType;
	AlertTypes = AlertTypes;

	private offcanvasService = inject(OffcanvasService);

	actionClick(actionClick: () => void, mustClose: boolean = false): void {
		actionClick();
		if (mustClose) {
			this.close();
		}
	}

	close(): void {
		this.offcanvasService.dismissLast();
	}
}
